import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 py-24">
      <div className="relative max-w-2xl mx-auto text-center">
        <div className="absolute -inset-10 bg-yellow-400/10 blur-3xl rounded-full pointer-events-none" />
        <div className="relative">
          <div className="text-[8rem] md:text-[10rem] font-extrabold leading-none text-yellow-400 drop-shadow-[0_0_30px_rgba(250,204,21,0.4)]">
            404
          </div>
          <h1 className="mt-4 text-3xl md:text-4xl font-bold text-white">Cette page s'est envolée de la ruche</h1>
          <p className="mt-4 text-neutral-400 max-w-md mx-auto leading-relaxed">
            La page que tu cherches n'existe pas ou a été déplacée. Reviens à l'accueil ou explore les autres sections de BuzzBump.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-yellow-400 text-neutral-900 font-semibold hover:bg-yellow-300 transition-colors"
            >
              <Home size={18} /> Retour à l'accueil
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md border border-white/20 text-white hover:border-yellow-400 hover:text-yellow-400 transition-colors"
            >
              <ArrowLeft size={18} /> Page précédente
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
